import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { AnimatePresence, MotionConfig, motion } from 'motion/react';
import { fadeThrough } from './utils/motion';
import './views/utils/Global.css';
import ScrollToTop from './components/ScrollToTop';
import Header from './views/utils/components/header/Header';
import Footer from './views/utils/components/footer/Footer';

import ResultadosPage from './views/pages/resultados/ResultadosPage';
import PreguntasPage from './views/pages/preguntas/PreguntasPage';
import ApuestasPage from './views/pages/apuestas/ApuestasPage';
import ProfilePage from './views/pages/profile/profilePage';
import AuthPage from './views/pages/auth/authPage';
import CartPage from './views/pages/carrito/cartPage';
import HistoryPage from './views/pages/profile/components/history/historyPage';
import WelcomePage from './views/pages/welcome/WelcomePage';
import NotFoundPage from './views/pages/notFound/NotFoundPage';
import BlogListPage from './views/pages/blog/BlogListPage';
import BlogPostPage from './views/pages/blog/BlogPostPage';
import PromocionesPage from './views/pages/promociones/PromocionesPage';
import PromocionDetailPage from './views/pages/promociones/PromocionDetailPage';
import RaffleTermsPage from './views/pages/promociones/RaffleTermsPage';

/** Redirección full-page a HTML estático (evita NotFound del SPA). */
function HardRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
}

function AppLayout() {
  const location = useLocation();
  return (
    <>
      <Header />
      <main className="app-main">
        {/* Fade-through por pathname; Routes recibe location para que la página saliente
            conserve su contenido durante la salida. */}
        <AnimatePresence mode="wait" initial={false}>
          <motion.div
            key={location.pathname}
            variants={fadeThrough}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            <Routes location={location}>
              <Route path="/resultados" element={<ResultadosPage />} />
              <Route path="/ayuda" element={<PreguntasPage />} />
              <Route
                path="/preguntas-frecuentes"
                element={<Navigate to="/ayuda" replace />}
              />
              <Route
                path="/soporte"
                element={<Navigate to="/ayuda" replace />}
              />
              <Route
                path="/politicas"
                element={<HardRedirect to="/politica-de-privacidad/" />}
              />
              <Route path="/apuestas" element={<ApuestasPage />} />
              <Route path="/perfil" element={<ProfilePage />} />
              <Route path="/historial" element={<HistoryPage />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/carrito" element={<CartPage />} />
              <Route path="/blog" element={<BlogListPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/promociones" element={<PromocionesPage />} />
              <Route path="/promociones/:slug" element={<PromocionDetailPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </motion.div>
        </AnimatePresence>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/welcome" element={<WelcomePage />} />
          <Route path="/welcome/:slug" element={<WelcomePage />} />
          {/* Alias alineado con el admin Django: /landing/{slug}/ */}
          <Route path="/landing/:slug" element={<WelcomePage />} />
          <Route path="/" element={<Navigate to="/welcome" replace />} />
          <Route path="/home" element={<Navigate to="/welcome" replace />} />
          {/* T&C permanentes de una rifa (enlace del comprobante): página pública e imprimible. */}
          <Route path="/terminos-rifa/:slug" element={<RaffleTermsPage />} />
          <Route path="/*" element={<AppLayout />} />
        </Routes>
      </BrowserRouter>
    </MotionConfig>
  );
}

export default App;
